import type { ResolvedThemeInterface } from 'redoc/typings';
import { logoStyles } from '@constants/logo';
import config from '@config';

globalThis.Redoc.init(
  config.redocSpecUrl,
  {
    hideDownloadButton: true,
    theme: {
      ...logoStyles
    } as ResolvedThemeInterface,
    codeSamplesLanguages: ['json', 'xml', 'csv'],
    requestSamplesLanguages: ['curl', 'python']
  },
  document.getElementById('redoc-container')
);
